import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

class ButtonBadge extends Component {

    render() {

        const { classes } = this.props;
        return (
            <div className={classes.root}>
                {this.props.count}
            </div>
        );
    }
}

ButtonBadge.propTypes = {
    count: PropTypes.number.isRequired,
};

ButtonBadge.defaultProps = {
    count: 0,
};

const styles = {
    root: {
        position: "absolute",
        right: "5px",
        bottom: "0px",
        fontSize: "15px",
},
};

export default withStyles(styles)(ButtonBadge);
